import React, { useRef } from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const Failed = (props) => {
    const popupRef = useRef(null);
    const { headerTitle, statusText, statusCancelTitle } = usePageMessages();

    return (
        <>
            <InfoPage
                animatedIconFail
                headerText={headerTitle}
                secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                primaryButtonCaption={statusCancelTitle}
                primaryButtonType="link"
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    props.toggleSpinner(true);
                    window.location.href =
                        props.status && props.status.showInviteCodeReferralButton ? AUTH_PROFILE_INVITE + '?showPromoSliders=true' : AUTH_SEND_MAIN_LINK;
                }}
            />
            <PopupNew ref={popupRef} />
        </>
    );
};

export default Failed;
